import { Component, TemplateRef, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-tooltip',
    imports: [NgbTooltip],
    template: `
        <span class="fa-solid fa-circle-info text-primary" [ngbTooltip]="tooltip()"></span>
    `,
})
export class TooltipIcon {
    readonly tooltip = input<string | TemplateRef<unknown> | null | undefined>(null);
}